// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type UnifiedGroupIdentity from "../contract/UnifiedGroupIdentity";

export default function unifiedGroupIdentity(data: UnifiedGroupIdentity): UnifiedGroupIdentity {
    const result: UnifiedGroupIdentity = {
        __type: "UnifiedGroupIdentity:#Exchange",
        ...data,
    };
    
    return result;
}
